import { useState, createContext, Dispatch } from 'react'
import { toast } from 'react-toastify'

import { useLocalStorage } from '@/hooks/useLocalStorage'
import {
  authenticationDataService,
  authenticationService
} from '@/services/Login'

import { setStorage } from '@/services/utils'
import { redirectPage } from '../utils'

interface ILogin {
  children: React.ReactNode
}

type LoginContextData = {
  CUSTOMER_DATA: any
  LOGIN_DATA: any
  LOGIN: (params?: any) => Promise<void>
  AUTHENTICATE: (params?: any) => Promise<void>
  LOGOUT: (params?: any) => {}
  SET_CUSTOMER_DATA: (params?: any) => void
}

export const LoginContext = createContext({} as LoginContextData)

export function LoginProvider({ children }: ILogin) {
  const [CUSTOMER_DATA, SET_CUSTOMER_DATA] = useState(null)
  const [LOGIN_DATA, SET_LOGIN_DATA] = useState({})
  const [, setUser] = useLocalStorage<Dispatch<any>>('user')

  async function LOGIN(param: { email: string; password: string }) {
    try {
      const res: any = await authenticationService.login(param)
      const { token, id, permissoes } = res.data

      if (token && permissoes) {
        SET_DATA_IN_STORAGE(res.data)
        SET_LOGIN_DATA({ id, token })
        return
      }

      SET_LOGIN_DATA({ id })
      setStorage('timer-2fa', new Date().toISOString())
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  async function AUTHENTICATE(params: { id: string; code: string }) {
    try {
      const res = await authenticationService.authenticate(params)
      SET_DATA_IN_STORAGE(res.data)
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  async function GET_CUSTOMER(id: string) {
    try {
      const [userData, profileTypesData] = await Promise.all([
        authenticationDataService.customerData(id),
        authenticationService.getPermission()
      ])
      const [user] = userData.data.data.rows
      const profileList = profileTypesData.data.data
      const profileRole = profileList?.find(
        (item: { roleId: string }) => item?.roleId === user?.perfilUsuarioId
      )
      setUser({...user, perfilUsuario: profileRole?.name})
      toast.success('Bem vindo!')
      redirectPage('disconnect', 'home')
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  async function SET_DATA_IN_STORAGE(data: any) {
    setStorage('avalia-token', data.token)
    await GET_CUSTOMER(data.id)

    if (data)
      setStorage(
        'user-data',
        JSON.stringify({
          userId: data.id,
          menusAvailable: data.permissoes ?? []
        })
      )
  }

  async function LOGOUT() {
    try {
      await authenticationService.logout()
      localStorage.clear()

      redirectPage('avalia-token', 'login')
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  return (
    <LoginContext.Provider
      value={{
        SET_CUSTOMER_DATA,
        CUSTOMER_DATA,
        LOGIN,
        LOGOUT,
        LOGIN_DATA,
        AUTHENTICATE
      }}
    >
      {children}
    </LoginContext.Provider>
  )
}
